import React from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import {AuthProvider, useAuth} from './context/AuthContext';

import Dashboard from './components/Pages/Dashboard';
import EventImport from './components/Pages/EventImport';
import EventmatchingSelection from "./components/Pages/EventmatchingSelection";
import Leistungspakete from "./components/Pages/Leistungspakete";
import LeistungspaketeStandort from "./components/Pages/LeistungspaketeStandort";
import LeistungspaketeSelection from "./components/Pages/LeistungspaketeSelection";
import Login from './components/Pages/Login';
import MfaVerification from "./components/Pages/MfaVerification";
import Personal from "./components/Pages/Personal";
import Plantafel from "./components/Pages/Plantafel";
import Stundenkontingente from "./components/Pages/Stundenkontingente";
import StundenkontingenteSpecialImport from "./components/Pages/StundenkontingenteSpecialImport";
import StundenkontingenteSelection from "./components/Pages/StundenkontingenteSelection";
import PersonalImport from "./components/Pages/PersonalImport";

import Layout from "./components/Layout";
import LeistungspaketeImport from "./components/Pages/LeistungspaketeImport";
import StundenkontingenteImport from "./components/Pages/StundenkontingenteImport";
import Forecast from "./components/Pages/Forecast";

const PrivateRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {

        return (
            <div className="bg-gray-100 min-h-screen flex items-center justify-center"></div>
        );
    }

    return user ? children : <Navigate to="/login" replace />;
};

const App = () => {
    return (

            <Router>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/mfa-verify" element={<MfaVerification />} />

                        {/* Alle geschützten Seiten unter Layout */}
                        <Route
                            element={
                                <PrivateRoute>
                                    <Layout />
                                </PrivateRoute>
                            }
                        >
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/eventImport" element={<EventImport />} />
                            <Route path="/plantafel" element={<Plantafel />} />
                            <Route path="/eventmatching" element={<EventmatchingSelection />} />
                            <Route path="/personal" element={<Personal />} />
                            <Route path="/leistungspaketeAuswahl" element={<LeistungspaketeSelection />} />
                            <Route path="/leistungspakete" element={<Leistungspakete />} />
                            <Route path="/leistungspakete/:eventType" element={<LeistungspaketeStandort />} />
                            <Route path="/leistungspakete/import" element={<LeistungspaketeImport />} />
                            <Route path="/stundenkontingenteAuswahl" element={<StundenkontingenteSelection />} />
                            <Route path="/stundenkontingente" element={<Stundenkontingente />} />
                            <Route path="/stundenkontingente/import" element={<StundenkontingenteImport />} />
                            <Route path="/stundenkontingente/import/special" element={<StundenkontingenteSpecialImport />} />
                            <Route path="/personal/import" element={<PersonalImport />} />
                            <Route path="/personal/forecast" element={<Forecast />} />

                        </Route>
                    </Routes>
                </AuthProvider>
            </Router>

    );
};

export default App;